export enum NotificationKeys {
  AcceptAllMatchSuggestions = 'accept-all-match-suggestions',
  AcceptAllMatchSuggestionsError = 'accept-all-match-suggestions-error',
  AccessDenied = 'access-denied',
  AccountArchive = 'account-archive',
  AccountDelete = 'account-delete',
  AccountFromTemplateCreate = 'account-from-template-create',
  AccountFromTemplateUpdate = 'account-from-template-update',
  AccountingSettings = 'accounting-settings',
  AccountingSettingsLockDate = 'accounting-settings-lock-date',
  ActorCreate = 'actor-create',
  ActorDelete = 'actor-delete',
  AssetCreate = 'asset-create',
  BankAccountCustomNameEdit = 'bank-account-custom-name-edit',
  BankAccountDownloadTransactionsError = 'bank-account-download-transactions-error',
  BankAccountEdit = 'bank-account-edit',
  BankReconciliationAllApprovedMatchesReconcile = 'bank-reconciliation-all-approved-matches-reconcile',
  BankReconciliationBulkReconcile = 'bank-reconciliation-bulk-reconcile',
  BankReconciliationConnectionEmailBounced = 'bank-reconciliation-connection-email-bounced',
  BankReconciliationHeaderExport = 'bank-reconciliation-header-export',
  BankReconciliationMatchReconcile = 'bank-reconciliation-match-reconcile',
  BankReconciliationMatchUnmatch = 'bank-reconciliation-match-unmatch',
  BankReconciliationMatchUnreconcile = 'bank-reconciliation-match-unreconcile',
  BankReconciliationTransactionCreatedAndReconcile = 'bank-reconciliation-transaction-created-and-reconcile',
  BankReconciliationUpdateBankLinesError = 'bank-reconciliation-update-bank-lines-error',
  BankReconciliationDownloadLinesError = 'bank-reconciliation-download-lines-error',
  BankStatementUpload = 'bank-statement-upload',
  BillIntegrationSyncRetryFailed = 'bill-integration-sync-retry-failed',
  BillIntegrationSyncRetrySuccess = 'bill-integration-sync-retry-success',
  BillAttachmentFilesUpdate = 'bill-attachment-files-update',
  BillAttachmentFileDuplicate = 'bill-attachment-file-duplicate',
  BillPaymentVoided = 'bill-payment-voided',
  BillReconciliationError = 'bill-reconciliation-error',
  BillReconciliationSuccess = 'bill-reconciliation-success',
  BillsList = 'bills-list',
  ChangeEmailAddress = 'change-email-address',
  ContactDeleted = 'contact-deleted',
  ContactsImport = 'contacts-import',
  ContactPersonDeleted = 'contact-person-deleted',
  ContactPaymentCreated = 'contact-payment-created',
  ContactStatementExport = 'contact-statement-export',
  CompanyInformationUpdated = 'company-information-updated',
  CopyableInfo = 'copyable-info',
  CreateAddress = 'create-address',
  CreateBankAccount = 'create-bank-account',
  CreateContact = 'create-contact',
  CreateContactPerson = 'create-contact-person',
  CreateManualPaymentReconciliation = 'create-manual-payment-reconciliation',
  CreateOrEditAdditionalFields = 'create-or-edit-additional-fields',
  CreateOrEditRulesets = 'create-or-edit-rulesets',
  CreateOrEditVatAccounts = 'create-or-edit-vat-accounts',
  CreateOrEditVatRates = 'create-or-edit-vat-rates',
  CurrencyDefaultPaymentMethodDelete = 'currency-default-payment-method-delete',
  CurrencyDefaultPaymentMethodUpdate = 'currency-default-payment-method-update',
  CustomersInvitations = 'customers-invitations',
  CustomersBalanceExport = 'customers-balance-export',
  DashboardCustomization = 'dashboard-customization',
  DashboardWidgetBillsUpload = 'dashboard-widget-bills-upload',
  DashboardWidgetBillsUploadFileRejections = 'dashboard-widget-bills-upload-file-rejections',
  DashboardWidgetTaskApprove = 'dashboard-widget-task-approve',
  DashboardWidgetTaskComplete = 'dashboard-widget-task-complete',
  DashboardWidgetTaskCreate = 'dashboard-widget-task-create',
  DashboardWidgetVat = 'dashboard-widget-vat',
  DaybookTransactionAttachmentFilesUpdate = 'daybook-transaction-attachment-files-update',
  DuplicateReceiptDeleted = 'duplicate-receipt-deleted',
  DuplicateReceiptKeptBoth = 'duplicate-receipt-kept-both',
  DaybookTransactionReversed = 'daybook-transaction-reversed',
  DaybookTransactionReverseFailed = 'daybook-transaction-reverse-failed',
  DaybookTransactionVoided = 'daybook-transaction-voided',
  DaybookTransactionVoidFailed = 'daybook-transaction-void-failed',
  DocumentsDownload = 'documents-download',
  DocumentsPreviewFetch = 'documents-preview-fetch',
  DebtCollectionServiceDisabled = 'debt-collection-service-disabled',
  DebtCollectionServiceEnabled = 'debt-collection-service-enabled',
  DocumentsCopyLink = 'documents-copy-link',
  DocumentsCreateFolder = 'documents-create-folder',
  DocumentsDeleteDocument = 'documents-delete-document',
  DocumentsDeleteFolder = 'documents-delete-folder',
  DocumentsItemUnavailable = 'documents-item-unavailable',
  DocumentsMoveItem = 'documents-move-item',
  EInvoiceCancel = 'e-invoice-cancel',
  EInvoiceSave = 'e-invoice-save',
  EInvoiceSend = 'e-invoice-send',
  EInvoiceKYCCompanyDetailsError = 'e-invoice-kyc-company-details-error',
  EInvoiceKYCCreateDocumentError = 'e-invoice-kyc-create-document-error',
  EInvoiceKYCFileDropRejected = 'e-invoice-kyc-file-drop-rejected',
  EInvoiceKYCUploadFileError = 'e-invoice-kyc-upload-file-error',
  EInvoiceKYCSignatureError = 'e-invoice-kyc-signature-confirm-error',
  EInvoiceDisablingError = 'e-invoice-disabling-error',
  EInvoiceDisablingSuccessful = 'e-invoice-disabling-successful',
  ExportsBackupSend = 'exports-backup-send',
  ExpertBalanceSheetExport = 'expert-balance-sheet-export',
  ExpertProfitAndLossExport = 'expert-profit-and-loss-export',
  ExpertTrialBalanceExport = 'expert-trial-balance-export',
  ExportsFecReportSend = 'exports-fec-report-send',
  ExternalInvoiceApproved = 'external-invoice-approved',
  ExternalInvoiceDeleted = 'external-invoice-deleted',
  ExternalInvoiceDraftDeleted = 'external-invoice-draft-deleted',
  ExternalInvoiceDownloadAsPdf = 'external-invoice-downloaded-as-pdf',
  ExternalInvoiceDownloadAsXml = 'external-invoice-downloaded-as-xml',
  ExternalInvoiceMarkedAsSent = 'external-invoice-marked-as-sent',
  ExternalInvoiceUnmarkedAsSent = 'external-invoice-unmarked-as-sent',
  ExternalInvoiceSavedAsDraft = 'external-invoice-saved-as-draft',
  ExternalInvoiceSentAsEmail = 'external-invoice-sent-as-email',
  ExternalInvoiceSentAsEInvoice = 'external-invoice-sent-as-e-invoice',
  ExternalInvoiceSettingsLogoRejected = 'external-invoice-settings-logo-rejected',
  ExternalInvoiceSettingsUpdate = 'external-invoice-settings-saved',
  ExternalInvoicesSyncStarted = 'external-invoices-sync-started',
  ExternalInvoicesSyncUpdated = 'external-invoices-sync-updated',
  FailureSubmit = 'failure-submit',
  FindAccountant = 'find-accountant',
  ImportedInvoiceApprove = 'imported-invoice-approve',
  ImportedInvoiceReviewNotFound = 'imported-invoice-review-not-found',
  ImportedInvoicesUpload = 'imported-invoices-upload',
  ImportedInvoicesUploadRejection = 'imported-invoices-upload-rejection',
  InvoiceEditorFormValidationError = 'invoice-editor-form-validation-error',
  InvoiceEmailSend = 'invoice-email-send',
  InvoiceSettingsUpdate = 'invoice-settings-update',
  InvoiceTemplateCreate = 'invoice-template-create',
  InvoiceTemplateDelete = 'invoice-template-delete',
  InvoiceTemplateDuplicate = 'invoice-template-duplicate',
  InvoiceTemplateSetAsDefault = 'invoice-template-set-as-default',
  InvoiceVoided = 'invoice-voided',
  InvoicingSettingsSave = 'invoicing-settings-save',
  LoginError = 'login-error',
  ModalDelete = 'modal-delete',
  ModalDiscard = 'modal-discard',
  ModalMoreInfo = 'modal-more-info',
  MultipleContacts = 'multiple-contacts',
  OnboardingStepSubmitError = 'onboarding-step-submit-error',
  OpenBankingConnectionRenewed = 'open-banking-connection-renewed',
  OrganizationIconDelete = 'organization-icon-delete',
  OrganizationIconUpload = 'organization-icon-upload',
  OrganizationIconUploadRejection = 'organization-icon-upload-rejection',
  OrganizationInvitation = 'organization-invitation',
  OrganizationLogoDelete = 'organization-logo-delete',
  OrganizationLogoUpload = 'organization-logo-upload',
  OrganizationLogoUploadRejection = 'organization-logo-upload-rejection',
  OrganizationOwnerDelete = 'organization-owner-delete',
  OrganizationReset = 'organization-reset',
  OrganizationSettingsUpdate = 'organization-settings-update',
  OrganizationSubscriptionCouponRedeem = 'organization-subscription-coupon-redeem',
  OrganizationSubscriptionPeriodChange = 'organization-subscription-period-change',
  OrganizationSubscriptionUpdate = 'organization-subscription-update',
  PasswordChangeAcceptance = 'password-change-acceptance',
  PasswordChangeRejection = 'password-change-rejection',
  PayNowStatusUpdateError = 'paynow-status-update-error',
  PaymentRemindersSettingsSaveError = 'payment-reminders-settings-save-error',
  PaymentMethodCreateError = 'payment-method-create-error',
  PaymentMethodDelete = 'payment-method-delete',
  PayNowConnectError = 'paynow-connect-error',
  PayNowConnectSuccess = 'paynow-connect-success',
  ProductBulkDeleted = 'product-bulk-deleted',
  ProductCreated = 'product-created',
  ProductDeleted = 'product-deleted',
  ProductUpdated = 'product-updated',
  ProductsExport = 'products-export',
  ProductsImport = 'products-import',
  ProductsList = 'products-list',
  ProfilePicDeleteSuccess = 'profile-pic-delete-success',
  ProfilePicDeleteError = 'profile-pic-delete-error',
  ProfilePicUploadAcceptance = 'profile-pic-upload-acceptance',
  ProfilePicUploadRejection = 'profile-pic-upload-rejection',
  QuoteDeleted = 'quote-deleted',
  QuoteFetchFailed = 'quote-fetch-failed',
  QuoteMarkedAsSent = 'quote-marked-as-sent',
  QuoteStatusUpdated = 'quote-status-updated',
  QuoteUpdated = 'quote-updated',
  ReceiptsList = 'receipts-list',
  RecurringInvoicesSpawnEnable = 'recurring-invoices-spawn-enable',
  RecurringInvoiceSavedAsDraft = 'recurring-invoice-saved-as-draft',
  RecurringInvoiceSavedAndActivated = 'recurring-invoice-saved-and-activated',
  RecurringInvoiceStatusUpdate = 'recurring-invoice-status-update',
  RemoveMobilePayPaymentMethod = 'remove-mobilepay-payment-method',
  ReportsExportPdf = 'reports-export-pdf',
  ReportsExportCsv = 'reports-export-csv',
  ReportsExportXlsx = 'reports-export-xlsx',
  ReviewEntriesBulkValidate = 'review-entries-bulk-validate',
  ReviewEntryValidate = 'review-entry-validate',
  SalesTaxSalesWithoutVat = 'sales-tax-sales-without-vat',
  SalesReportDownloadXlsx = 'sales-report-download-xslx',
  SalesReportDownloadPdf = 'sales-report-download-pdf',
  SalesReportDownloadCsv = 'sales-report-download-csv',
  SalesReportDownloadInvoices = 'sales-report-download-invoices',
  ScoutConnectionUpdate = 'scout-connection-update',
  ScoutConnectionImapCreateSuccess = 'scout-connection-imap-create-success',
  ScoutConnectionImapCreateError = 'scout-connection-imap-create-error',
  SettingsUserProfile = 'settings-user-profile',
  ShineInitiateConnectionError = 'shine-initiate-connection-error',
  SignupUserError = 'signup-user-error',
  SkatRequest = 'skat-request',
  StripeAccountDisconnected = 'stripe-account-disconnected',
  SubscriptionPaymentCancelled = 'subscription-payment-cancelled',
  SubscriptionPaymentFailed = 'subscription-payment-failed',
  SubscriptionPaymentSuccessful = 'subscription-payment-successful',
  SubscriptionStripe = 'subscription-stripe',
  SuppliersBalanceExport = 'suppliers-balance-export',
  ThingsToDoMissingInfo = 'things-to-do-missing-info',
  ThingsToDoMissingReceipts = 'things-to-do-missing-receipts',
  ThingsToDoMissingReceiptsUpdate = 'things-to-do-missing-receipts-update',
  TransferOwnership = 'transfer-ownership',
  UmbrellaInvoicingDetails = 'umbrella-invoicing-details',
  UmbrellaOrganizationChangeSubscription = 'umbrella-organization-change-subscription',
  UmbrellaOrganizationDelete = 'umbrella-organization-delete',
  UmbrellaOrganizationUpdateConsolidatedBilling = 'umbrella-organization-update-consolidated-billing',
  UmbrellaOrganizationUpdateVoucherInbox = 'umbrella-organization-update-voucher-inbox',
  UmbrellaProfileForm = 'umbrella-profile-form',
  UmbrellaProfileLogoUploadAcceptance = 'umbrella-profile-logo-acceptance',
  UmbrellaProfileLogoUploadRejection = 'umbrella-profile-logo-upload',
  UmbrellaRoleUpdate = 'umbrella-role-update',
  UmbrellaRolesDelete = 'umbrella-roles-delete',
  UmbrellaSubscriptionsPaymentStatus = 'umbrella-subscriptions-payment-status',
  UmbrellaTypeform = 'umbrella-typeform',
  UmbrellaUserDelete = 'umbrella-user-delete',
  UmbrellaUserInvitation = 'umbrella-user-invitation',
  UmbrellaUserInvitationDelete = 'umbrella-user-invitation-delete',
  UmbrellaUserUpdate = 'umbrella-user-update',
  UpdateContact = 'update-contact',
  UpdateExistingAccount = 'update-existing-account',
  UpdateProductsVatError = 'update-products-vat-error',
  UpdateProductsVatSuccess = 'update-products-vat-success',
  UpdateAddress = 'update-address',
  UploadFiles = 'upload-files',
  VatDeclarationAuditTrail = 'vat-declaration-audit-trail',
  VatDeclarationExportCsv = 'vat-declaration-export-csv',
  VatDeclarationExportXlsx = 'vat-declaration-export-xlsx',
  VatDeclarationsChangePeriod = 'vat-declarations-change-period',
  VatDeclarationsDefinePayout = 'vat-declarations-define-payout',
  VatDeclarationsExport = 'vat-declarations-export',
  VatDeclarationsRegisterPayment = 'vat-declarations-register-payment',
  VatDeclarationsSettle = 'vat-declarations-settle',
  VatDeclarationsVoidPayment = 'vat-declarations-void-payment',
  VatDeclarationsVoidSettlement = 'vat-declarations-void-settlement',
  VatSuggestionsApplySuccess = 'vat-suggestions-apply-success',
  VatSuggestionsApplyError = 'vat-suggestions-apply-error',
  VoucherInboxArchive = 'voucher-inbox-archive',
  VoucherInboxBillCreate = 'voucher-inbox-bill-create',
  VoucherInboxBulkDelete = 'voucher-inbox-bulk-delete',
  VoucherInboxDelete = 'voucher-inbox-delete',
  VoucherInboxDiscard = 'voucher-inbox-discard',
  VoucherInboxDublicate = 'voucher-inbox-dublicate',
  VoucherInboxEntryReconcile = 'inbox-entry-reconcile',
  VoucherInboxFetch = 'voucher-inbox-fetch',
  VoucherInboxInfoRequest = 'voucher-inbox-info-request',
  VoucherInboxJounalCreate = 'voucher-inbox-journal-create',
  VoucherInboxListFetch = 'voucher-inbox-list-fetche',
  VoucherInboxPostpone = 'voucher-inbox-postpone',
  VoucherInboxReceive = 'voucher-inbox-receive',
  VoucherInboxUpdate = 'voucher-inbox-update',
}
